import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

// Composants partagés
import { GalleryPhotoComponent } from 'src/app/components/views-photos/gallery-photo/gallery-photo.component';
import { ImageViewerComponent } from '../components/views-photos/image-viewer/image-viewer.component';
import { CameraComponent } from '../components/camera/camera.component';
import { ImageProcessingComponent } from '../components/edit-photo/image-processing/image-processing.component';
import { CustomSpinnerComponent } from '../components/custom-spinner/custom-spinner.component';
import { AligneurComponent } from '../components/planDeTraitement/aligneur/aligneur.component';
import { BibaguesComponent } from '../components/planDeTraitement/bibagues/bibagues.component';
import { RccComponent } from '../components/planDeTraitement/rcc/rcc.component';
import { DentComponent } from '../components/planDeTraitement/dent/dent.component';

// Directives / Modules externes
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { ZoomDirective } from '../zoom-directive/zoom.directive';
import { ListViewAllModule } from '@syncfusion/ej2-angular-lists';

// Services
import { Context } from './services/context.service';
import { UserService } from '../service/user.service';
import { LoadingService } from './services/LoadingService.service';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { ElastiqueComponent } from '../pages/basdiag/Modals/elastique/elastique.component';
import { SuivisPdtComponent } from '../components/planDeTraitement/suivis-pdt/suivis-pdt.component';
import { FacturationComponent } from '../components/planDeTraitement/facturation/facturation.component';
import { PdtDetailsComponent } from '../components/planDeTraitement/pdt-details/pdt-details.component';
import { PdtCommentsComponent } from '../components/planDeTraitement/pdt-comments/pdt-comments.component';
import { SynchrophotoComponent } from '../pages/basdiag/Modals/synchrophoto/synchrophoto.component';

@NgModule({
  declarations: [
    GalleryPhotoComponent,
    CameraComponent,
    ImageViewerComponent,
    ImageProcessingComponent,
    CustomSpinnerComponent,
    ZoomDirective,
    AligneurComponent,
    SuivisPdtComponent,
    BibaguesComponent,
    RccComponent,
    DentComponent,
    ElastiqueComponent,
    FacturationComponent,
    PdtCommentsComponent,
    PdtDetailsComponent,
    SynchrophotoComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    VirtualScrollerModule,
    ListViewAllModule,
    ImageCropperModule,
    PinchZoomModule,
    DialogModule,
  ],
  exports: [
    // Composants exportés pour réutilisation
    GalleryPhotoComponent,
    CameraComponent,
    ImageViewerComponent,
    ImageProcessingComponent,
    CustomSpinnerComponent,
    ZoomDirective,
    AligneurComponent,
    SuivisPdtComponent,
    BibaguesComponent,
    RccComponent,
    DentComponent,
    ElastiqueComponent,
    FacturationComponent,
    PdtCommentsComponent,
    PdtDetailsComponent,
    SynchrophotoComponent
  ],
  providers: [
    Context,
    UserService,
    LoadingService
  ],

})
export class SharedModule { }
